'use client';

import { MobileLayout } from './MobileLayout';
import { NavCategory, ServiceList, DocumentList } from '@/types';
import type { FooterData } from './Footer';

interface City {
  id: string;
  cityName: string;
  urlStructure: string;
}

interface MobileLayoutWrapperProps {
  children: React.ReactNode;
  cities: City[];
  allCityNavigation?: Record<string, NavCategory[]>;
  initialCity?: string;
  allCityServices?: Record<string, ServiceList[]>;
  documents?: DocumentList[];
  allCityFooterData?: Record<string, FooterData | null>;
}

export function MobileLayoutWrapper({ children, cities, allCityNavigation = {}, initialCity = 'bangalore', allCityServices = {}, documents = [], allCityFooterData = {} }: MobileLayoutWrapperProps) {
  return (
    <MobileLayout
      cities={cities}
      allCityNavigation={allCityNavigation}
      initialCity={initialCity}
      showBottomNav={true}
      showFooter={true}
      allCityServices={allCityServices}
      documents={documents}
      allCityFooterData={allCityFooterData}
    >
      {children}
    </MobileLayout>
  );
}
